export const projects = [

  {
    title: "Investigate Patient Appointment Dataset",
    subtitle: "Python, Pandas, Numpy and Matplotlib",
    description:
      "This project entails Cleaning and Analyzing patient Appointment dataset to investigate the factor that willl cause them not to respect their appointment date",
    image: "./project1.PNG",
    link: "https://github.com/codeamic/Investigate-a-dataset",
  },

  {
    title: "Data Wrangling",
    subtitle: "Python, Pandas, Numpy, Matplotlib, and Tweepy",
    description:
      "This project entails Gathering data from different sources and in different formats,Cleaning and merging the various datasets as required and bringing out insights from the data",
    image: "./project 2",
    link: "https://github.com/codeamic/Wrangle-and-analyze-Data",
  },

  {
    title: "Data Visualisation(Analyzing and communicating insights from Proper Loan Dataset",
    subtitle: "Python, Pandas, Numpy, Matplotlib, and Tweepy",
    description:
      "This project entails Gathering and cleaning prosperLoan dataset, Analyzing and bringing out insights from this dataset(Determining the risk of giing out loan to members with certain criteria)",
      image: "./project 2",
    link: "https://github.com/codeamic/Communicate-Data-Findings",
  },

  {
    title: "Schoolkit Project",
    subtitle: "Adobe XD",
    description:
      "Prototype of my react-native and flutter social media application using adobe xd",
    image: "./prototype.gif",
    link: "./#contact",
  },

  {
    title: "Schoolkit Project",
    subtitle: "Flutter and firebase",
    description:
      "Instagram-like but school oriented social media using flutter and firebase",
    image: "./Portfolio1.gif",
    link: "./#contact",
  },

  {
    title: "Schoolkit Project",
    subtitle: "React-Native and firebase",
    description:
      "Instagram clone using Reat-Native and firebase",
    image: "./react.png",
    link: "./#contact",
  },
 
  {
    title: "Hotel Management System UI",
    subtitle: "Java(Swing)",
    description:
      "This is a hotel mananagement system using java (swing)",
    image: "./hotel.gif",
   link: "./#contact",
  },

   {
    title: "Scientific calculator",
    subtitle: "VB.net",
    description:
      "Calculator using Vb.net",
    image: "./calculator.gif",
    link: "./#contact",
  },
  
];

export const testimonials = [
  {
    quote:
      "The first day Mr. Sango Pascal came to my office to ressolve our IT related problems, i minimised his capacity due to his age but he was able to resolve all the IT related issues in our office and gave us preventive measures to take inorder to minimise risks when we encounter a problem ",
    image: "./Geraldine.jpg",
    name: "Ngasa Geraldine",
    company: "BAMCULL",
  },
  {
    quote:
      "Mr Sango pascal is a great IT specialist, he has the knowledge and skills to resolve any IT problem in my clinic, he created an online presence for my clinic and helped to analyze my database which gave me profitable insight",
    image: "./FAMES.jpg",
    name: "FAMES",
    company: "FAITH BASED MEDICAL SERVICES",
  },
];

export const skills = [
  "Data Analysis",
  "Data Cleaning",
  "Microsoft Packages",
  "Tableau",
  "Data Visualization",
  "JavaScript",
  "React",
  "React Native",
  "Wix(Velo)",
  "Wordpress",
  "Flutter",
  "Adobe XD",
  "Adobe Photoshop",
  "Java",
  "SpringBoot",
  "C++",
  "C",
  "HTML",
  "CSS",
  "PHP",
  "MYSQL",
  "Bootstrap",
  "Computer repair and Maintenace",
  "Computer Network",

];



// WEBPACK FOOTER //
// ./src/data.js